import { IOutOfOfficeRequest } from '../../interfaces/out-of-office/IOutOfOfficeRequest';
import { IPaginationProps } from '../../interfaces/IPaginationProps';
import { IOutOfOfficeRequestCommentCreate } from '../../interfaces/out-of-office/IOutOfOfficeRequestComment';

export class LoadOutOfOfficeRequests {
  static readonly type = '[OutOfOffice] LoadRequests';

  constructor(
    public paginationProps: IPaginationProps,
    public requiresAction: boolean,
  ) {}
}

export class LoadOutOfOfficeRequestById {
  static readonly type = '[OutOfOffice] LoadRequestById';

  constructor(public requestId: number) {}
}

export class CreateOutOfOfficeRequest {
  static readonly type = '[OutOfOffice] CreateRequest';

  constructor(public request: IOutOfOfficeRequest) {}
}

export class UpdateOutOfOfficeRequest {
  static readonly type = '[OutOfOffice] UpdateRequest';

  constructor(public request: IOutOfOfficeRequest) {}
}

export class DeleteOutOfOfficeRequest {
  static readonly type = '[OutOfOffice] DeleteRequest';

  constructor(public requestId: number) {}
}

export class CreateOutOfOfficeRequestComment {
  static readonly type = '[OutOfOffice] CreateComment';

  constructor(
    public requestId: number,
    public comment: IOutOfOfficeRequestCommentCreate,
  ) {}
}

export class DeleteOutOfOfficeRequestComment {
  static readonly type = '[OutOfOffice] DeleteComment';

  constructor(
    public requestId: number,
    public commentId: number,
  ) {}
}

export class ClearSelectedOutOfOfficeRequest {
  static readonly type = '[OutOfOffice] ClearSelectedRequest';
}
